import Tabs from "components/CustomTabs/CustomTabs.jsx";

import React from 'react';
import EmailIcon from "@material-ui/icons/Email";
import MobileIcon from "@material-ui/icons/Phone";
import EmailsPanel from "./EmailsPanel";
import MobileNumberPanel from "./MobileNumberPanel";

const selectedTab = (key) => {
  // this.setState({currentTab: key})
};

const UpdateModal = ({user, handleSelect, classes, airports, airportCode2, handleChange, handleChangeEmail, handleChangeMobileNumber, additionalMobileNumbers, additionalEmails, editedEmail, activeEditEmail, editedMobileNumbers, handleActiveInput, activeEditMobileNumber}) => {
    return (
        <div>
            <Tabs  // getKey = {this.getkey}
                headerColor="regional"
                tabs={[
                    {
                        tabName: "Emails",
                        tabIcon: EmailIcon,
                      clickEvent: (key) => selectedTab(key),
                      tabContent: (
                            <EmailsPanel
                                handleChangeEmail={handleChangeEmail}
                                handleActiveInput={handleActiveInput}
                                classes={classes} editedEmail={editedEmail}
                                activeEditEmail={activeEditEmail}
                                additionalEmails={additionalEmails} handleChange={handleChange} />
                        )
                    },
                    {
                        tabName: "Mobile Numbers",
                        tabIcon: MobileIcon,
                        clickEvent: (key) => selectedTab(key),
                      tabContent: (
                            <MobileNumberPanel
                                handleActiveInput={handleActiveInput}
                                handleSelect = {handleSelect}
                                handleChangeMobileNumber={handleChangeMobileNumber}
                                classes={classes}
                                user= {user}
                                airports= {airports}
                                airportCode2= {airportCode2}
                                editedMobileNumbers={editedMobileNumbers}
                                activeEditMobileNumber={activeEditMobileNumber}
                                additionalMobileNumbers={additionalMobileNumbers}
                                handleChange={handleChange} />
                        )
                    }
                ]}
            />
        </div>
    );
};

export default UpdateModal;



// WEBPACK FOOTER //
// ./src/Regional-Views/EmailSettings/UpdateModal.js